import type { MouseEventHandler } from 'react';

import { ButtonBase } from '@mui/material';

import type { SxProps } from '@mui/material';

const clearAllButton = ({
  onClick,
  sx
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps;
}) => (
  <ButtonBase
    sx={{
      color: 'primary.main',
      fontSize: '16px',
      ...sx
    }}
    onClick={onClick}
  >
    Clear all
  </ButtonBase>
);

export default clearAllButton;
